import { render, staticRenderFns } from "./youtube-popup.vue?vue&type=template&id=1c2c0c8c&scoped=true"
import script from "./youtube-popup.vue?vue&type=script&lang=js"
export * from "./youtube-popup.vue?vue&type=script&lang=js"
import style0 from "./youtube-popup.vue?vue&type=style&index=0&id=1c2c0c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c0c8c",
  null
  
)

export default component.exports